import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceUtil } from './service.util';
import { ConfigService } from '../services/config.service';  // TODO: Deprecate
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import DevExpress from 'devextreme/bundles/dx.all';

@Injectable()
export class SgPortalDataApiServiceUtil {

	private get settings(): any { return this._configService.appSettings; }
	public get sgPortalApiServer(): string { return this.settings.sgPortalApiServer; }

	constructor
	(
		private _http: HttpClient,
		private _serviceUtil: ServiceUtil,
		private _configService: ConfigService
	) {}

	async doPostRequestAsync<T, U>(controller: string, action: string, body: T): Promise<U> {
		const header = this._serviceUtil.getJsonContentTypeHeader();

		return this._http.post<U>(
			`${this.sgPortalApiServer}/${controller}/${action}`,
			JSON.stringify(body), { headers: header })
			.toPromise();
	}

	async doGetRequestAsync<T>(controller: string, action: string): Promise<T> {
		const header = this._serviceUtil.getJsonContentTypeHeader();

		return this._http.get<T>(
			`${this.sgPortalApiServer}/${controller}/${action}`,
			{ headers: header })
			.toPromise();
	}

	async doPostRequestWithParamsAsync<T, U>(controller: string, action: string, body: T, params: HttpParams): Promise<U> {
		const header = this._serviceUtil.getJsonContentTypeHeader();

		return this._http.post<U>(
			`${this.sgPortalApiServer}/${controller}/${action}`,
			JSON.stringify(body), { headers: header, params: params })
			.toPromise();
	}
}
